export enum EtatCivil {
    'Célibataire', 'Marié-e', 'Divorcé-e', 'Séparé-e', 'Veuf/Veuve', 'En couple', 'Inconnu'
}
